export const AREA_COLORS = [
  '#5b8cff',
  '#a66cff',
  '#5de2a5',
  '#ffb85b',
  '#ff647c',
  '#38d9e6',
  '#ff8ad8',
  '#c5e86c',
  '#ff9f43',
  '#7c83fd',
  '#b0bec5',
  '#ffd43b',
] as const

export type AreaColor = (typeof AREA_COLORS)[number]

export interface Area {
  id: string
  name: string
  color: AreaColor
  xp: number
  activeObjectiveName: string | null
  createdAt: number
  updatedAt: number
}

export interface AreaDraft {
  name: string
  color: AreaColor
}

export const levelFor = (xp: number) => Math.floor(xp / 1000) + 1
export const levelXp = (xp: number) => xp % 1000
